import moment from 'moment';
import { storageListSelect, staffListSelect, getListMethod, delListMethod } from "@/utils/api"
export const warehouselist = {
    data() {
        return {
            isLoding: true,
            documentTypeList: [],
            warehouseList: [],
            agentList: [],
            dataSource: [],
            formData: {
                contactCustomerName: '',
                confirmFlag: null
            },
            dateValue: null,
            ipagination: {
                current: 1,
                pageSize: 10,
                showTotal: (total, range) => {
                    return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 100
            },

            tableHeight: '',
            contentHeight: ''
        }
    },
    activated() {
        this.init()
    },
    methods: {
        init() {
            // 表格高度计算
            let _that = this
            setTimeout(function() {
                let tdHeight = document.getElementsByTagName('tr')[0].offsetHeight
                let header = document.getElementById("header").offsetHeight;
                let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
                let pageHeight = document.getElementById('content').offsetHeight
                let makeTop = document.getElementById('page-top').offsetHeight
                _that.contentHeight = pageHeight - makeTop - header - breadcrumb - tdHeight * 0.8
                _that.tableHeight = _that.contentHeight - tdHeight * 2
            }, 50)
            this.getMenuList()
            this.getStorageList()
            this.getStaffListSelect()
        },
        moment,
        range(start, end) {
            const result = [];
            for (let i = start; i < end; i++) {
                result.push(i);
            }
            return result;
        },

        disabledDate(current) {
            // Can not select days before today and today
            return current && current > moment().endOf('day');
        },

        disabledRangeTime(_, type) {
            if (type === 'start') {
                return {
                    disabledHours: () => this.range(0, 60).splice(4, 20),
                    disabledMinutes: () => this.range(30, 60),
                    disabledSeconds: () => [55, 56],
                };
            }
            return {
                disabledHours: () => this.range(0, 60).splice(20, 4),
                disabledMinutes: () => this.range(0, 31),
                disabledSeconds: () => [55, 56],
            };
        },
        // 选择筛选日期
        changeData(date, dateString) {
            this.dateValue = date
            this.formData.startTime = dateString[0]
            this.formData.endTime = dateString[1]
        },
        // 选择出库类型
        selectType(e) {
            this.formData.inboundType = this.typeList[e].id
            this.formData.outboundType = this.typeList[e].id
            this.formData.typeName = this.typeList[e].name
        },
        // 获取仓库列表
        getStorageList() {
            let params = new FormData()
            params.append("companyStoreId", this.$store.state.userInfo.companyStoreId)
            storageListSelect(params).then((res) => {
                if (res.code == 200) {
                    this.warehouseList = res.result
                } else {
                    this.$message.error(res.logMessage)
                }
            })
        },
        // 获取经办人列表
        getStaffListSelect() {
            let params = new FormData()
            params.append("companyStoreId", this.$store.state.userInfo.companyStoreId)
            staffListSelect(params).then((res) => {
                if (res.code == 200) {
                    this.agentList = res.result
                } else {
                    this.$message.error(res.logMessage)
                }
            })
        },
        // 选择仓库
        selectWarehouse(e) {
            this.formData.storageId = this.warehouseList[e].id
            this.formData.storageName = this.warehouseList[e].storageName
        },
        // 选择往来单位
        btnReceiptModel() {
            this.$refs.receipt.onOpen()
        },
        // 选择往来单位
        onSelectModel(data) {
            this.formData.contactCustomerName = data.contactCustomerName ? data.contactCustomerName : data.contactName
            this.formData.contactCustomerId = data.id
        },
        changeContactCustomer() {
            if (!this.formData.contactCustomerName) {
                this.formData.contactCustomerId = ''
                this.btnInquire()
            }
        },
        // 选择经办人
        selectAgent(e) {
            this.formData.transactorId = this.agentList[e].id
            this.formData.transactorName = this.agentList[e].name
        },
        // 页面变化时回调
        onChangeIpagination(current) {
            this.ipagination.current = current
            this.getMenuList()
        },
        // 一页显示条数变化时回调
        onShowSizeChange(current, pageSize) {
            this.ipagination.current = current
            this.ipagination.pageSize = pageSize
            this.getMenuList()
        },
        // 重置数据
        btnResetData() {
            this.dateValue = null
            this.ipagination.current = 1
            this.ipagination.pageSize = 10
            this.formData.confirmFlag = null
            this.formData = {
                contactCustomerName: ''
            }
            this.getMenuList()
        },
        // 筛选
        btnInquire() {
            this.ipagination.current = 1
            this.ipagination.pageSize = 10
            this.getMenuList()
        },
        // 获取表格数据
        getMenuList() {
            let params = {
                keyWord: this.formData.keyWord,
                companyId: this.$store.state.userInfo.companyId,
                companyStoreId: this.$store.state.userInfo.companyStoreId,
                contactCustomerId: this.formData.contactCustomerId,
                endTime: this.formData.endTime,
                startTime: this.formData.startTime,
                inboundType: this.formData.inboundType,
                outboundType: this.formData.outboundType,
                storageId: this.formData.storageId
            }
            let data = {
                pageNo: this.ipagination.current,
                pageSize: this.ipagination.pageSize
            }
            this.$store.state.isLoding = true
            getListMethod(this.urlList.list, params, {}, data).then((res) => {
                if (res.success) {
                    this.dataSource = res.result.records
                    this.ipagination.total = parseInt(res.result.total)
                    this.$store.state.isLoding = false
                }
            })
            getListMethod(this.urlList.price, params).then((res) => {
                if (res.success) {
                    this.footerDataSource[0].stockCount = res.result.totalCount
                    this.footerDataSource[0].totalAmount = res.result.totalAmount
                    this.$store.state.isLoding = false
                }
            })
        }
    }
}